import { BaseDto } from "./base.dto";
import { MerchantGroupDto } from './merchantGroup.dto';

export class PriceBracketDto extends BaseDto {
    id: number;
    merchantGroup: MerchantGroupDto;
    merchantGroupId: number;
    name: string;
    startDate?: Date;
    endDate?: Date;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?:number;
    isStaffFood?: boolean;

}